import { customEvent } from '@jspartials/general-utils';

document.addEventListener('DOMContentLoaded', function () {
  document.dispatchEvent(new CustomEvent(customEvent.loginAndSignupLoaded));
});
